import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
    providedIn: 'root'
})
export class GlobalEntityService {

    environment = EnvironmentService.environment

    constructor(private httpClient: HttpClient) { }
    GetCustomers = (obj = {}) => {
        return this.httpClient.post(`${this.environment.TargetBaseUrl}/Global/GetCustomers`, obj);
    }
    GetSuppliers = (obj = {}) => {
        return this.httpClient.post(`${this.environment.TargetBaseUrl}/Global/GetSuppliers`, obj);
    }
}

